import { render, staticRenderFns } from "./index.vue?vue&type=template&id=19d16960&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=19d16960&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../environment/web_node_modules/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d16960",
  null
  
)

export default component.exports